import {Injectable} from '@angular/core';
import {I18nPipe} from "../i18n/i18n.pipe";

declare var $: any;

@Injectable()
export class NotificationService {

    public mapCanvas: boolean = false;
    private confirm1: string = this.i18n.transform("Operation complete");
    private areYouSure: string = this.i18n.transform("Are you sure?");
    private activar: string = this.i18n.transform("Activate?");
    private confirmarActivar: string = this.i18n.transform("You are about to activate the format");
    private errorActivating: string = this.i18n.transform("Error activating");
    private desactivar: string = this.i18n.transform("Deactivate?");
    private confirmarDesactivar: string = this.i18n.transform("You are about to deactivate the format");
    private errorDeactivating: string = this.i18n.transform("Error deactivating");
    private delete: string = this.i18n.transform("Delete");
    private errorDeleting: string = this.i18n.transform("Error deleting");

    constructor(private i18n: I18nPipe) {
        i18n.i18nService.subscribe(() => {
            this.confirm1 = this.i18n.transform("Operation complete");
            this.areYouSure = this.i18n.transform("Are you sure?");
            this.activar = this.i18n.transform("Activate?");
            this.confirmarActivar = this.i18n.transform("You are about to activate the format");
            this.errorActivating = this.i18n.transform("Error activating");
            this.desactivar = this.i18n.transform("Deactivate?");
            this.confirmarDesactivar = this.i18n.transform("You are about to deactivate the format");
            this.errorDeactivating = this.i18n.transform("Error deactivating");
            this.delete = this.i18n.transform("Delete");
            this.errorDeleting = this.i18n.transform("Error deleting");
        }, null)
    }

    smallBox(data, cb?) {
        $.smallBox(data, cb)
    }

    bigBox(data, cb?) {
        $.bigBox(data, cb)
    }

    smartMessageBox(data, cb?) {
        $.SmartMessageBox(data, cb)
    }

    getConfirm1(): string {
        return this.confirm1;
    }

    getAreYouSure(): string {
        return this.areYouSure;
    }

    getActivar(): string {
        return this.activar;
    }

    getConfirmarActivar(): string {
        return this.confirmarActivar;
    }

    getErrorActivating(): string {
        return this.errorActivating;
    }

    getDesactivar(): string {
        return this.desactivar;
    }

    getConfirmarDesactivar(): string {
        return this.confirmarDesactivar;
    }

    getErrorDeactivating(): string {
        return this.errorDeactivating;
    }

    getDelete(): string {
        return this.delete;
    }

    getErrorDeleting(): string {
        return this.errorDeleting;
    }
}